import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, unref as _unref, vShow as _vShow, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_2 = { class: "text-sm" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "font-bold font-gotham" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "mt-6 bg-white dark:bg-gray-900" }
const _hoisted_7 = { class: "mt-2 -space-y-px rounded-md shadow-sm" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = ["type"]
const _hoisted_10 = { class: "flex absolute inset-y-0 right-0" }
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = ["type"]
const _hoisted_13 = { class: "flex absolute inset-y-0 right-0" }
const _hoisted_14 = {
  id: "password-match-indicator",
  class: "pr-3 flex items-center pointer-events-none relative z-20"
}
const _hoisted_15 = { class: "text-red-600 w-full justify-center text-sm h-16 py-2 items-end flex" }
const _hoisted_16 = { class: "text-center mt-2" }
const _hoisted_17 = { class: "flex flex-col justify-between h-full" }
const _hoisted_18 = { class: "space-y-8" }
const _hoisted_19 = { class: "text-sm mt-2" }

import { 
		Auth
	} from 'aws-amplify'

	// components
	import TwConfirmationCode from '@/components/InputGroups/TwConfirmationCode.vue'

	import {
		CheckCircleIcon
	} from '@heroicons/vue/24/outline'

	import {
		CheckCircleIcon as CheckCircleIconMini,
		EyeIcon as EyeIconMini,
		EyeSlashIcon as EyeSlashIconMini
	} from '@heroicons/vue/20/solid'

	// router
	import {
		useRoute
	} from 'vue-router'
	
	// utilities
	import {
		isValidEmail
	} from '@/utilities/email'

	// vue
	import {
		computed,
		onMounted,
		ref,
		watch
	} from 'vue'

	
	const __default__ = { name: 'ForgotPasswordForm' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	// api
	const route = useRoute()

	const currentRoute = computed( () => {
		return route.name
	})

	// sign in passes the email in history state rather than the URL; it survives a reload but not a new tab
	const requestedEmail = currentRoute.value === 'ResetPasswordRequested' ? String(window.history.state?.email ?? "") : ""

	const email = ref(requestedEmail)
	const emailError = ref("")
	const newPassword = ref("")
	const confirmNewPassword = ref("")
	const loading = ref(false)
	const showCode = ref<boolean>(requestedEmail !== "")
	const message = ref<string>('')
	const code = ref<string>('')
	const changeSuccessful = ref<boolean>(false)
	const showPassword = ref<boolean>(false)

	const passwordsMatch = computed(() => {
		return newPassword.value && (newPassword.value === confirmNewPassword.value)
	})

	onMounted(() => {
		if (requestedEmail) {
			resetPassword()
		}
	})

	const submitButton = computed<string>(() => {
		return showCode.value ? 'Resend Code' : 'Submit'
	})

	// hide the format error as soon as the user edits the email again
	watch(email, () => {
		emailError.value = ""
	})

	async function resetPassword() {
		loading.value = true
		message.value = ""

		if (email.value == "") {
			document.getElementById('email')?.focus()
			loading.value = false
			return
		}

		if (!isValidEmail(email.value)) {
			emailError.value = "Please enter a valid email address."
			document.getElementById('email')?.focus()
			loading.value = false
			return
		}

		try {
			await Auth.forgotPassword(email.value)
			showCode.value = true
		}
		catch(error) {
			if(String(error).includes('LimitExceededException')) {
				message.value = "Password reset attempts exceeded. Please try again later."
			}
			else if(String(error).includes('UserNotFoundException')) {
				showCode.value = true
				return
			}
			else if(String(error).includes('Cannot reset password for the user as there is no registered/verified email')){
				message.value = "Password cannot be reset. Your account has not been confirmed. Please return to the customer login and log in again."
			}
			console.error(error)
		}
		finally {
			loading.value = false
		}
	}

	async function confirmCode() {
		try {
			loading.value = true
			message.value = ""

			if(!passwordsMatch.value) {
				throw 'PasswordMismatchException'
			}

			let username = email.value
			let password = confirmNewPassword.value
			await Auth.forgotPasswordSubmit(username, code.value, password)
			showCode.value = false
			changeSuccessful.value = true
		}
		catch (error) {
			if(String(error).includes('CodeMismatchException')) {
				message.value = "Invalid verification code provided. Please try again."
			}
			else if(String(error).includes('InvalidPasswordException')) {
				message.value = "New password does not satisfy requirements. Please try again."
			}
			else if(String(error).includes('ExpiredCodeException')) {
				message.value = "Verification code has expired. Please resend the code using the button below and try again."
			}
			else if(String(error).includes('PasswordMismatchException')) {
				message.value = "Passwords do not match. Please try again."
			}
			console.error(error)
		}
		finally {
			loading.value = false
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_input = _resolveComponent("tw-input")!
  const _component_tw_button = _resolveComponent("tw-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", null, [
      (!showCode.value)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (resetPassword()), ["prevent"]))
          }, [
            _createElementVNode("div", null, [
              _createVNode(_component_tw_input, {
                modelValue: email.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                id: "email",
                required: true,
                type: "email",
                autocomplete: "email",
                label: "Email address",
                validation: "Please enter your email address.",
                error: emailError.value
              }, null, 8, ["modelValue", "error"])
            ])
          ], 32))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (currentRoute.value === 'ResetPasswordRequested')
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, " You must update your password before logging in. "))
                : _createCommentVNode("", true),
              _createElementVNode("p", null, [
                _cache[6] || (_cache[6] = _createTextVNode("An email has been sent to ")),
                _createElementVNode("span", _hoisted_4, _toDisplayString(email.value), 1),
                _cache[7] || (_cache[7] = _createTextVNode(" containing a verification code. Please enter the code and a new password below to finish updating your password."))
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(TwConfirmationCode, {
                modelValue: code.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((code).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-sm" }, [
              _createElementVNode("p", null, " Your new password must contain: "),
              _createElementVNode("ul", { class: "list-disc pl-8" }, [
                _createElementVNode("li", null, " At least 8 characters ")
              ])
            ], -1)),
            _createElementVNode("fieldset", _hoisted_6, [
              _cache[10] || (_cache[10] = _createElementVNode("legend", { class: "block text-sm font-bold leading-6 text-gray-900 dark:text-gray-200" }, " New Password ", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", {
                    for: "password",
                    class: "sr-only"
                  }, "New password", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newPassword).value = $event)),
                      type: showPassword.value ? 'text' : 'password',
                      name: "new-password",
                      id: "password",
                      autocomplete: "new-password",
                      class: "pr-12 relative min-w-0 block w-full rounded-none rounded-t-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-dbBlue sm:text-sm sm:leading-6 dark:bg-white/5 dark:text-white dark:ring-white/10 dark:focus:ring-indigo-500",
                      placeholder: "New password"
                    }, null, 8, _hoisted_9), [
                      [_vModelDynamic, newPassword.value]
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        id: "show-hide-password",
                        tabindex: "-1",
                        class: "pr-3 flex items-center text-gray-300 dark:text-gray-500 z-20",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (showPassword.value = !showPassword.value), ["prevent"]))
                      }, [
                        _withDirectives(_createVNode(_unref(EyeIconMini), {
                          class: "h-5 w-5",
                          "aria-hidden": "true",
                          tabindex: "-1"
                        }, null, 512), [
                          [_vShow, !showPassword.value]
                        ]),
                        _withDirectives(_createVNode(_unref(EyeSlashIconMini), {
                          class: "h-5 w-5",
                          "aria-hidden": "true",
                          tabindex: "-1"
                        }, null, 512), [
                          [_vShow, showPassword.value]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", {
                    for: "confirm-password",
                    class: "sr-only"
                  }, "Confirm new password", -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((confirmNewPassword).value = $event)),
                      type: showPassword.value ? 'text' : 'password',
                      name: "confirm-password",
                      id: "confirm-password",
                      autocomplete: "new-password",
                      class: "pr-12 relative min-w-0 block w-full rounded-none rounded-b-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-dbBlue sm:text-sm sm:leading-6 dark:bg-white/5 dark:text-white dark:ring-white/10 dark:focus:ring-indigo-500",
                      placeholder: "Confirm new password"
                    }, null, 8, _hoisted_12), [
                      [_vModelDynamic, confirmNewPassword.value]
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_unref(CheckCircleIconMini), {
                          class: _normalizeClass([{'opacity-0': !passwordsMatch.value}, "h-5 w-5 text-green-500 transition-all duration-300 ease-in-out absolute right-3"]),
                          "aria-hidden": "true"
                        }, null, 8, ["class"]),
                        _createVNode(_unref(CheckCircleIcon), {
                          class: _normalizeClass([{'opacity-0': passwordsMatch.value}, "h-5 w-5 text-gray-300 dark:text-gray-500 transition-all duration-300 ease-in-out absolute right-3"]),
                          "aria-hidden": "true"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_15, _toDisplayString(message.value), 1),
        _withDirectives(_createVNode(_component_tw_button, {
          onClick: confirmCode,
          disabled: loading.value,
          loading: loading.value,
          class: "btn-base btn-db-yellow w-full mb-4"
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [
            _createTextVNode(" Submit ")
          ])),
          _: 1,
          __: [12]
        }, 8, ["disabled", "loading"]), [
          [_vShow, showCode.value]
        ]),
        _createVNode(_component_tw_button, {
          onClick: resetPassword,
          class: _normalizeClass(["btn-base w-full", [showCode.value ? 'btn-white' : 'btn-db-yellow']]),
          disabled: loading.value,
          loading: loading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(submitButton.value), 1)
          ]),
          _: 1
        }, 8, ["class", "disabled", "loading"]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_router_link, {
            to: {name: 'SignIn'},
            class: "link"
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode(" Cancel ")
            ])),
            _: 1,
            __: [13]
          })
        ])
      ])
    ], 512), [
      [_vShow, !changeSuccessful.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_19, [
            _cache[15] || (_cache[15] = _createTextVNode(" Your password has been successfully updated. Please ")),
            _createVNode(_component_router_link, {
              to: {name: 'SignIn' },
              class: "link"
            }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createTextVNode(" Return to the Customer Login screen ")
              ])),
              _: 1,
              __: [14]
            }),
            _cache[16] || (_cache[16] = _createTextVNode(" to log in again. "))
          ])
        ])
      ])
    ], 512), [
      [_vShow, changeSuccessful.value]
    ])
  ], 64))
}
}

})